export let WAREHOUSE_TYPES = /*#__PURE__*/function (WAREHOUSE_TYPES) {
  WAREHOUSE_TYPES["IN_PRODUCTION"] = "IN_PRODUCTION";
  WAREHOUSE_TYPES["BUY"] = "BUY";
  WAREHOUSE_TYPES["RESERVE"] = "RESERVE";
  WAREHOUSE_TYPES["SELL"] = "SELL";
  WAREHOUSE_TYPES["PREORDER"] = "PREORDER";
  WAREHOUSE_TYPES["TRANSFER"] = "TRANSFER";
  WAREHOUSE_TYPES["ADJUSTMENT"] = "ADJUSTMENT";
  WAREHOUSE_TYPES["RESERVE_ADJUSTMENT"] = "RESERVE_ADJUSTMENT";
  return WAREHOUSE_TYPES;
}({});
export let TRANSACTION_TYPE = /*#__PURE__*/function (TRANSACTION_TYPE) {
  TRANSACTION_TYPE["DEFAULT"] = "DEFAULT";
  TRANSACTION_TYPE["BOX"] = "BOX";
  TRANSACTION_TYPE["BUNDLE"] = "BUNDLE";
  return TRANSACTION_TYPE;
}({});
export let IDistributionVariantsType = /*#__PURE__*/function (IDistributionVariantsType) {
  IDistributionVariantsType["GIVEAWAY"] = "Giveaway";
  IDistributionVariantsType["DISTRIBUTION"] = "Distribution";
  return IDistributionVariantsType;
}({});